import React, { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";
import { getApiCaller } from "../../../../../Libs/apiCaller";
import DeleteVec from "../../../../../Assets/Images/deleteVec.png";

export default function HardDeleteModal({ isOpen, onClose, onConfirm, user, isDeleting }) {
    const [mediaFiles, setMediaFiles] = useState([]);
    const [isLoadingMedia, setIsLoadingMedia] = useState(false);
    const [totalSize, setTotalSize] = useState("");

    useEffect(() => {
        if (isOpen && user) {
            fetchUserMedia();
        }
    }, [isOpen, user]);

    const fetchUserMedia = async () => {
        setIsLoadingMedia(true);
        try {
            const response = await getApiCaller(`users/${user._id}/media`);
            if (response.status === 200) {
                setMediaFiles(response.data.mediaFiles || []);
                setTotalSize(response.data.totalSizeFormatted || "0 Bytes");
            }
        } catch (error) {
            console.error("Error fetching media:", error);
        }
        setIsLoadingMedia(false);
    };

    if (!isOpen) return null;

    return (
        <div className="modal modal-open">
            <div className="modal-box relative bg-white max-w-2xl">
                <div className="flex items-center justify-between">
                    <h2 className="text-lg font-semibold">Permanently Delete User</h2>
                    <MdClose onClick={onClose} size={18} className="cursor-pointer" />
                </div>

                {/* Image */}
                <div className="flex justify-center mb-4">
                    <img src={DeleteVec} alt="Delete warning" />
                </div>

                {/* Warning Content */}
                <p className="capitalize text-md mb-2 text-center font-bold text-xl">
                    Are you sure you want to permanently delete this user?
                </p>
                <p className="text-sm text-gray-600 mb-4 text-center">
                    This action cannot be undone. All user data and media files will be permanently removed.
                </p>

                {/* User Info */}
                <div className="bg-gray-50 p-4 rounded-lg mb-4">
                    <p className="text-sm"><strong>Name:</strong> {user?.name}</p>
                    <p className="text-sm"><strong>Email:</strong> {user?.email}</p>
                    <p className="text-sm"><strong>Phone:</strong> {user?.phone}</p>
                </div>

                {/* Media Files Section */}
                <div className="border-t pt-4">
                    <h3 className="font-semibold mb-2">Media Files ({mediaFiles.length})</h3>
                    {isLoadingMedia ? (
                        <p className="text-sm text-gray-500">Loading media files...</p>
                    ) : mediaFiles.length > 0 ? (
                        <>
                            <p className="text-sm text-gray-600 mb-2">
                                Total storage: <strong>{totalSize}</strong>
                            </p>
                            <div className="max-h-40 overflow-y-auto bg-gray-50 p-2 rounded">
                                {mediaFiles.map((file, index) => (
                                    <div key={index} className="flex justify-between text-xs py-1 border-b last:border-b-0">
                                        <span className="truncate flex-1">{file.mediaUrl?.split('/').pop() || 'Unknown'}</span>
                                        <span className="text-gray-500 ml-2">{file.fileSizeFormatted}</span>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <p className="text-sm text-gray-500">No media files found</p>
                    )}
                </div>

                <div className="flex justify-center gap-10 mt-6">
                    <button
                        onClick={onClose}
                        disabled={isDeleting}
                        className="btn btn-outline btn-sm border border-[#EBEBEB] min-w-30 rounded-full min-h-[40px] hover:opacity-50 hover:bg-white hover:shadow-none hover:text-black"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isDeleting}
                        className="btn bg-[#F44336] btn-sm min-w-30 rounded-full shadow-none text-white p-2.5 min-h-[40px] hover:opacity-50"
                    >
                        {isDeleting ? "Deleting..." : "Yes, Delete Permanently"}
                    </button>
                </div>
            </div>
        </div>
    );
}
